var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIphoneMobileSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6665 0.666504H15.6665C15.1142 0.666504 14.6665 1.11422 14.6665 1.6665V10.3332C14.6665 10.8855 15.1142 11.3332 15.6665 11.3332H16.6665C17.2188 11.3332 17.6665 10.8855 17.6665 10.3332V1.6665C17.6665 1.11422 17.2188 0.666504 16.6665 0.666504ZM10.9998 2.99984H11.9998C12.5521 2.99984 12.9998 3.44755 12.9998 3.99984V10.3332C12.9998 10.8855 12.5521 11.3332 11.9998 11.3332H10.9998C10.4476 11.3332 9.99984 10.8855 9.99984 10.3332V3.99984C9.99984 3.44755 10.4476 2.99984 10.9998 2.99984ZM7.33317 5.33317H6.33317C5.78089 5.33317 5.33317 5.78089 5.33317 6.33317V10.3332C5.33317 10.8855 5.78089 11.3332 6.33317 11.3332H7.33317C7.88546 11.3332 8.33317 10.8855 8.33317 10.3332V6.33317C8.33317 5.78089 7.88546 5.33317 7.33317 5.33317ZM2.6665 7.33317H1.6665C1.11422 7.33317 0.666504 7.78089 0.666504 8.33317V10.3332C0.666504 10.8855 1.11422 11.3332 1.6665 11.3332H2.6665C3.21879 11.3332 3.6665 10.8855 3.6665 10.3332V8.33317C3.6665 7.78089 3.21879 7.33317 2.6665 7.33317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneMobileSignal);
export default __webpack_public_path__ + "static/media/iphone-mobile-signal.92b1fb60.svg";
export { ForwardRef as ReactComponent };